import { render } from "./OptStatViewManager.vue?vue&type=template&id=4f0c88fc&scoped=true"
import script from "./OptStatViewManager.vue?vue&type=script&lang=js"
export * from "./OptStatViewManager.vue?vue&type=script&lang=js"

import "./OptStatViewManager.vue?vue&type=style&index=0&id=4f0c88fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0c88fc"]])

export default __exports__